import { defineMessages } from 'react-intl';

export default defineMessages({

    users: {
        id: "ri.admin.manageRI_user.list.RI_Users",
        defaultMessage: "RI_Users"
    },
    userid: {
        id: "ri.admin.manageRI_user.list.UserId",
        defaultMessage: "UserId"

    },
    name: {
        id: "ri.admin.manageRI_user.list.Name",
        defaultMessage: "Name"
    },
    created: {
        id: "ri.admin.manageRI_user.list.Created",
        defaultMessage: "Created"
    },
    email: {
        id: "ri.admin.manageRI_user.list.Email",
        defaultMessage: "Email"
    },
    userManager: {
        id: "ri.admin.manageRI_user.list.User Manager",
        defaultMessage: "User Manager"
    },
    lastAccess: {
        id: "ri.admin.manageRI_user.list.Last Access",
        defaultMessage: "Last Access"
    },
    Billing: {
        id: "ri.admin.manageRI_user.list.Billing",
        defaultMessage: "Billing"
    },
    claim: {
        id: "ri.admin.manageRI_user.list.Claim",
        defaultMessage: "Claim"
    },
    marketing: {
        id: "ri.admin.manageRI_user.list.Marketing",
        defaultMessage: "Marketing"
    },
    searchUser: {
        id: "ri.admin.manageRI_user.list.Search Users by (Name / user ID)",
        defaultMessage: "Search Users by (Name / user ID)"
    },
    newUser: {
        id: "ri.admin.manageRI_user.list.Add New User",
        defaultMessage: "Add New User"
    },    
});
